export const setStateCallback =
  <TState>(setState: (state: TState) => void) =>
  (state: TState) =>
  () => {
    setState(state);
  };
